import React from 'react';
import { Navbar } from '../Navbar';
interface HeaderProps {
  children?: React.ReactNode;
}
export const Header = ({
  children
}: HeaderProps) => {
  return <header data-id="element-2653">
      <Navbar data-id="element-2654" />
      {children}
    </header>;
};